import React, {Component} from "react";
import PropTypes from 'prop-types';
import { auth } from "../actions/auth";
import { getTypes } from "../actions";
import { connect } from "react-redux";

class Auth extends Component {
  componentDidMount() {
    this.props.authAction();
  }

  render() {
    return this.props.children;
  }
}

Auth.propTypes = {
  authAction: PropTypes.func.isRequired,
  loaders: PropTypes.shape({}).isRequired,
};

function mapStateToProps(state) {
  return {
    loaders: state.forms.loaders,
    state: state
  };
}

const mapDispatchToProps = {
  authAction: auth,
  getTypes
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
